module.exports = __webpack_public_path__ + "static/media/primary_baseball.d3d23b20.png";